// client/components/forms/modules/ModuleBlock.jsx
// Generischer Modul-Block: rendert die Felder einer Modul-Definition dynamisch.
// Standardmässig zugeklappt — öffnet sich erst beim Klick.
import React from "react";
import { Input, Textarea } from "../shared/FormAtoms.jsx";
import { Label } from "../../ui/DatePickers.jsx";
import { MODULE_REGISTRY, getModuleFields } from "../../../../shared/config/formModules.js";
import { Building2, MapPin, UserRound, Receipt, Hash, Info, ChevronDown } from "lucide-react";
import AppButton from "../../ui/AppButton.jsx";
const ICON_MAP = {
  Building2,
  MapPin,
  UserRound,
  Receipt,
  Hash,
  Info
};
export default function ModuleBlock({
  moduleId,
  entityType = "projekt",
  values = {},
  onChange,
  collapsed: initialCollapsed = true
}) {
    const mod = MODULE_REGISTRY[moduleId];
  if (!mod) return null;
  const fields = getModuleFields(moduleId, entityType);
  if (!fields.length) return null;
  const IconComp = ICON_MAP[mod.icon];
  const [isCollapsed, setIsCollapsed] = React.useState(initialCollapsed);

  // Prüfe ob mindestens ein Feld befüllt ist (für Indikator-Dot)
  const hasData = fields.some(f => {
    const v = values[f.name];
    return v != null && String(v).trim() !== "";
  });
  return <div className={`md:col-span-2 rounded-lg border transition-all ${"border-white/10 bg-white/[0.02]"}`}>
      {/* Header — kompakt */}
      <AppButton type="button" variant="ghost" onClick={() => setIsCollapsed(v => !v)} className={`w-full justify-start font-normal flex items-center gap-2 px-3 py-2 text-left transition-colors ${isCollapsed ? "rounded-lg" : "rounded-t-lg"} ${"hover:bg-white/[0.03]"}`}>
        {IconComp && <IconComp className={`w-3.5 h-3.5 shrink-0 ${"text-blue-300/70"}`} />}
        <span className={`text-xs font-semibold uppercase tracking-wide flex-1 ${"text-blue-300/70"}`}>
          {mod.label}
        </span>
        {/* Indikator: Daten vorhanden */}
        {hasData && isCollapsed && <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${"bg-blue-400/60"}`} title="Daten vorhanden" />}
        <ChevronDown className={`w-3.5 h-3.5 shrink-0 transition-transform ${isCollapsed ? "" : "rotate-180"} ${"text-blue-300/40"}`} />
      </AppButton>

      {/* Felder — nur wenn offen */}
      {!isCollapsed && <div className="px-3 pb-3 pt-1 grid grid-cols-1 md:grid-cols-2 gap-3">
          {fields.map(field => {
        const val = values[field.name] ?? "";
        const isHalf = field.width === "half";
        const colSpan = isHalf ? "" : "md:col-span-2";
        return <div key={field.name} className={colSpan}>
                <Label htmlFor={`mod-${moduleId}-${field.name}`}>
                  {field.label}
                  {field.required && <span className="text-rose-400 ml-0.5">*</span>}
                </Label>
                {field.type === "textarea" ? <Textarea id={`mod-${moduleId}-${field.name}`} rows={field.rows || 2} value={val} onChange={e => onChange?.(field.name, e.target.value)} placeholder={field.placeholder} required={field.required} /> : <Input id={`mod-${moduleId}-${field.name}`} type={field.type || "text"} value={val} onChange={e => onChange?.(field.name, e.target.value)} placeholder={field.placeholder} required={field.required} />}
              </div>;
      })}
        </div>}
    </div>;
}